import { gql } from '__generated__';

export default gql(`
  query GetRegistrationFilters($project_id: ID!, $events: [ID!]) {
    project(id: $project_id) {
      id
      mail_permissions {
        id
        title
        integration {
          id
        }
      }
      events(ids: $events) {
        data {
          id
          title
          end_date
          ticket_categories {
            id
            title
            tickets {
              id
              title
              promotions {
                id
                title
              }
              time_slots {
                id
                start_date
                start_time
                title
                multi_date
              }
            }
          }
          products {
            id
            title
            stand_alone
            promotions {
              id
              title
            }
            product_variants {
              id
              title
            }
          }
          participant_fields {
            id
            title
            scope
            type
            enabled
            choices {
              id
              title
              enabled
            }
            tickets {
              id
            }
            products {
              id
            }
          }
          ticket_number_sequences {
            id
            title
          }
          invitations {
            id
            has_unique_codes
            prefix
          }
          coupons {
            id
            prefix
          }
          lotteries {
            id
            title
          }
        }
        current_page
        last_page
        per_page
        total
      }
    }
  }
`);
